export default __webpack_public_path__ + "static/media/10.b5a2e537.jpg";